if (!customElements.get('search-in-filter')) {
  class SearchInFilters extends HTMLElement {
    constructor() {
      super();
      this.cacheFilters = [];
      this.initSearchInFilters();
      this.populateCacheFilters();
    }
    initSearchInFilters() {
      this.searchSelectors = {
        searchBar: '.search-in-filter__input'
      };
      this.searchFiltersBar = this.querySelector(this.searchSelectors.searchBar);
      this.searchFilterparentEle = this.parentElement.querySelector('ul');

      this.debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
          }, delay);
        };
      };

      this.debouncedSearch = this.debounce(this.findEleInFilters.bind(this), 300);

      this.searchFiltersBar.addEventListener('input', (e) => {
        const searchValue = e.target.value;
        this.debouncedSearch(searchValue);
      });
    }

    populateCacheFilters() {
      const listItems = this.searchFilterparentEle.querySelectorAll('li');
      listItems.forEach(liElement => {
        if (liElement) {
          this.cacheFilters.push(liElement);
        }
      });
    }

    findEleInFilters(searchValue) {
      this.searchFilterparentEle.innerHTML = ''; // Clear previous search results

      const newSearch = this.cacheFilters.filter(ele => {
        const filterValue = ele.dataset.id.toLowerCase();
        return filterValue.includes(searchValue.toLowerCase());
      });

      if (newSearch.length === 0) {
        const newLiElement = document.createElement('li');
        newLiElement.textContent = 'No filter found';
        this.searchFilterparentEle.appendChild(newLiElement);
      } else {
        newSearch.forEach(ele => {
          this.searchFilterparentEle.appendChild(ele);
        });
      }
      const ulHeight = this.searchFilterparentEle.scrollHeight;
      // Set the height of the parent element
      this.searchFilterparentEle.parentElement.parentElement.style.height = (ulHeight + 60) + 'px';
    }
  }

  customElements.define('search-in-filter', SearchInFilters);
}
